import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { DragPreviewImage, useDrag } from 'react-dnd';
import PropTypes from 'prop-types';

import generateBlockContent from './generateBlockContent';
import handleKeyPress from '../../../common/handleKeyPress';
import * as itemTypes from '../../../constants/itemTypes/itemTypes';
import imageSources from '../../../constants/imageSources/imageSources';
import { blockType } from '../../../types';
import { useAddBlock } from '../../../common/useAddBlock';
import * as Styled from './styles';

const BlockLayout = ({ name, layout, label, firstInRow, lastInRow, lastBlock }) => {
    const dispatch = useDispatch();

    const addBlock = useAddBlock({ lastBlock, layout, dispatch, generateBlock: generateBlockContent });

    const [{ isDragging, handlerId }, drag, dragPreview] = useDrag({
        type: itemTypes.STATIC_BLOCK,
        item: () => {
            const newBlock = generateBlockContent(layout);
            return { newBlock };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(), // https://github.com/react-dnd/react-dnd/issues/2774
        }),
    });

    return (
        <div ref={drag}>
            <DragPreviewImage connect={dragPreview} src={imageSources.BLOCK_LAYOUTS_IMAGE_SOURCES(name, true)} />
            <div style={{ flexGrow: 1 }}>
                <Styled.Div
                    imageSource={imageSources.BLOCK_LAYOUTS_IMAGE_SOURCES(name, false)}
                    cursorSource={imageSources.ICONS.GRAB_CURSOR}
                    firstInRow={firstInRow}
                    lastInRow={lastInRow}
                    onClick={addBlock}
                    onKeyDown={(e) => handleKeyPress(e, addBlock)}
                    tabIndex={0}
                    key={`${name}-key`}
                    data-test-id={`${name}-block-layout`}
                    isDragging={isDragging}
                    data-handler-id={handlerId}
                    role="button"
                    aria-label={`Add block layout ${label} to canvas`}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    lastBlock: state.canvasBlocks.present[state.canvasBlocks.present.length - 1],
});

BlockLayout.propTypes = {
    name: PropTypes.string.isRequired,
    layout: PropTypes.arrayOf(PropTypes.number).isRequired,
    label: PropTypes.string.isRequired,
    firstInRow: PropTypes.bool,
    lastInRow: PropTypes.bool,
    lastBlock: blockType,
};

BlockLayout.defaultProps = {
    firstInRow: false,
    lastInRow: false,
    lastBlock: null,
};

export default connect(mapStateToProps)(BlockLayout);
